import React from 'react';
import ReactDOM from 'react-dom/client';

import 'assets/index.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter as Router } from 'react-router-dom';

import { Provider } from 'react-redux';
import { store } from 'store';

import './init/amplify.js';
import './init/app-metadata.js';
import './init/indexed-db.js';
import './init/i18n.js';
import './init/cloudwatch-rum';
import './init/offline-check';

(() => {
    try {
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(
            <React.StrictMode>
                <Provider store={store}>
                    <Router>
                        <App />
                    </Router>
                </Provider>
            </React.StrictMode>
        );
    } catch (e) {
        console.debug(e);
    }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
